<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-preparation-counter(v-if='prepareForGame && counter', :counter="counter")
            template(v-else-if="!prepareForGame")
                game-header(
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :time='getTime'
                    :slug="type"
                    :gameType="parameters.courseType"
                    :is-homework="!!exerciseId"
                )
                .play-box__game(v-if='!gameFinished && !prepareForGame && !isNextExampleButtonShown && !hideGameHeader')
                    .play-box__links(v-if='!gameFinished && !isNextExampleButtonShown')
                        a.play-box__link(href="javascript://", @click="rotateCarousel")
                            svg-icon.link__icon(name="spin", width="52px", height="52px")
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_rotateCarousel') }}
                    .play-box__example
                        .reels-container(v-if='showReels && !gameFinished && !isNextExampleButtonShown')
                            reels(
                                :couples='couples',
                                @dropItemInRightReel='dropItemInRightReel',
                                :game-started='gameStarted',
                                :mode='parameters.mode',
                                :drag-started='dragStarted',
                                :type-of-right-column='typeOfRightColumn',
                                :disable-reply-button='disableReplyButton',
                                :rotate-button-clicked="rotateButtonClicked"
                                @showPlayButton='showPlayButton = true',
                                @addFocusOnReplyButton='addFocusOnReplyButton',
                                :block-reels-scroll='blockReelsScroll',
                                @blockReelsScroll='blockReelsScroll = isDragging = true',
                                @unlockReelsScroll='blockReelsScroll = isDragging = false',
                                @dropItemInAnswersBox='dropItemInAnswersBox',
                                @endCarouselRotate="endCarouselRotate"
                                :is-mobile='isMobile'
                            )
                        .play-box__buttons.play-box__buttons--game(
                            v-if='!gameFinished && !isNextExampleButtonShown'
                        )
                            cs-button.play-box__button#reply-button(
                                v-if='gameStarted',
                                :disabled='disableReplyButton',
                                @click='processReply'
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                    drop.play-box__drop(@drop='dropItemInAnswersBox', v-if='!gameFinished && showAnswersContainer')
                        answer-container(
                            v-show="displayAnswersContainer"
                            :answers='itemsForAnswersBox',
                            :game-started='gameStarted',
                            :items-length="couples.length",
                            links-type='image',
                            @dragStarted='dragStarted = true',
                            @dragEnded='dragStarted = false'
                        )
                .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(
                        v-if='gameFinished && !isOlympiad && !prepareForGame',
                        :is-mobile='isMobile'
                    )
                    .play-box__reaction-container
                        result-image.play-box__image(:status="'success'")
                    result-buttons(
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        template(slot="mainButton")
                            cs-button(
                                v-if="isNextExampleButtonShown",
                                @click='getExample',
                                v-focus='',
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        slot
        cs-loader(v-else='')
</template>

<script>
    /*eslint-disable*/
    import CouplesGameItemsApi from '../../../../api/games/couplesGameItems';
    import Reels from './Reels.vue';
    import { Drag, Drop } from 'vue-drag-drop';
    import _ from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';

    import AnswerContainer from './AnswerContainer.vue'
    import GamePreparationCounter from '../../GamePreparationCounter.vue'

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA () {
        return {
            showPlayButton: false,
            chainOfAttempts: [[]],
            typeOfRightColumn: '',
            showReels: true,
            dragStarted: false,
            allInputsAreFilled: false,
            rightColumnWasDroppedFirstTime: false,
            blockReelsScroll: false,
            prepareForGame: true,
            amountOfExamples: 0,
            isNextExampleButtonShown: false,
            hideGameHeader: false,
            isAttemptCorrect: false,
            imageCouples: [],
            digitCouples: [],
            usedImages: [],
            itemsForAnswersBox: [],
            couples: [],
            isDragging: false,
            rotateButtonClicked: false,
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return DEFAULT_DATA();
        },
        watch: {
            couples: {
                handler (couples) {
                    if (this.typeOfRightColumn !== 'image') {
                        let allInputsAreFilled = _.find(couples, (couple) => {
                            return _.trim(couple.right.value).length === 0;
                        });
                        this.allInputsAreFilled = allInputsAreFilled === undefined;
                    }
                },
                deep: true,
                immediate: true
            },
        },
        computed: {
            showAnswersContainer () {
                return this.typeOfRightColumn === 'image' && this.gameStarted;
            },
            allPairsNotSettled () {
                return this.typeOfRightColumn === 'image' ? this.itemsForAnswersBox.length !== 0 : false;
            },
            disableReplyButton () {
                return this.allPairsNotSettled || !this.allInputsAreFilled;
            },
            goodAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.good);
                });
                return count;
            },
            badAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.bad);
                });
                return count;
            },
        },
        methods: {
            fetchData () {
                this.getExercise()
                    .then(() => {
                        this.getExample();
                        this.registerSounds();
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    })
            },
            beforeStart () {
                this.prepareForGame = false;
                if (!this.timer) {
                    this.setTimer();
                }
            },
            startGame () {
                this.gameStarted = true;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                this.dropRightColumn();
            },
            dropRightColumn () {
                this.showReels = false;
                this.$nextTick(() => {
                    if (this.typeOfRightColumn === 'image') {
                        this.couples.forEach(couple => {
                            this.itemsForAnswersBox.push(couple.right)
                        });
                        this.itemsForAnswersBox = _.shuffle(this.itemsForAnswersBox);
                        if (!this.rightColumnWasDroppedFirstTime) {
                            this.$nextTick(() => {
                                this.shakeAnswerBlocks();
                            });
                            this.rightColumnWasDroppedFirstTime = true;
                        }
                    }
                    let typeForEmptyCell = 'dropZone';
                    this.couples = this.couples.map(couple => {
                        couple.right = {
                            type: typeForEmptyCell,
                            value: ''
                        };
                        return couple;
                    });
                    this.showReels = true;
                });
            },
            dropItemInRightReel(index) {
                this.itemsForAnswersBox.splice(index, 1);
                this.dragStarted = false;
                this.isDragging = false;
            },
            dropItemInAnswersBox(couple) {
                if (couple.from !== 'answers-box') {
                    let item = _.cloneDeep(couple.item);
                    if (!this.isMobile) {
                        let dragEvent = arguments[arguments.length - 1];
                        let toDropIndex = dragEvent.srcElement.dataset.index;
                        if (toDropIndex) {
                            this.itemsForAnswersBox.splice(+toDropIndex, 0, item);
                        } else {
                            if (dragEvent.srcElement.childElementCount) {
                                toDropIndex = dragEvent.srcElement.children[0].dataset.index;
                                toDropIndex && this.itemsForAnswersBox.splice(+toDropIndex, 0, item);
                            }
                            !toDropIndex && this.itemsForAnswersBox.push(item);
                        }
                    } else {
                        this.itemsForAnswersBox.push(item);
                    }
                    this.couples[couple.index].right = {
                        type: 'dropZone'
                    };
                }
            },
            processReply () {
                this.stopAnswerTimer();
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 0
                };
                for (let index = 0; index < this.couples.length; index++) {
                    if (this.isItCorrectCouple(this.couples[index])) {
                        this.couples[index] = null;
                        elemOfExampleAttempts.good++;
                    } else {
                        elemOfExampleAttempts.bad++;
                    }
                }
                this.couples = this.couples.filter(element => element);
                this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                if (!this.couples.length) {
                    this.amountOfExamples++;
                    this.isAttemptCorrect = true;
                    this.hideGameHeader = true;
                    if (this.amountOfExamples === 1) {
                        this.couplesDone();
                        return;
                    }
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.resetData();
                    if  (this.isOlympiad) {
                        this.chainOfAttempts.push([]);
                        this.isNextExampleButtonShown = false;
                        this.getExample();
                    }
                    return;
                }
                if  (this.isOlympiad) {
                    this.resetData();
                    this.amountOfExamples++;
                    this.chainOfAttempts.push([]);
                    this.isNextExampleButtonShown = false;
                    this.isAttemptCorrect = false;
                    if (this.amountOfExamples === 1) {
                        this.couplesDone();
                        return;
                    }
                    this.getExample();
                }
                this.updateCouples()
                this.dropRightColumn();
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.isAttemptCorrect = false;
                    this.sendStat();
                }
            },
            resetData () {
                this.isNextExampleButtonShown = true;
                this.gameStarted = false;
                this.hideGameHeader = false;
                this.showReels = false;
                this.rightColumnWasDroppedFirstTime = false;
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
                this.stopTimer();
                this.timer = null;
                this.couples = [];
                this.itemsForAnswersBox = [];
            },
            getExample () {
                if (this.isAttemptCorrect && !this.isOlympiad) {
                    this.chainOfAttempts.push([]);
                    this.sendStat();
                }
                this.isLoading = true;
                let paramsForRequest = {
                    amountOfPairs: this.parameters.amountOfPairs,
                };
                CouplesGameItemsApi.getDigitCouples(paramsForRequest)
                    .then(couples => {
                        couples.forEach(couple => {
                            couple.type === 'image'
                              ? this.imageCouples.push(couple)
                              : this.digitCouples.push(couple)
                        });
                        this.fillCouples();
                        this.typeOfRightColumn = 'image';
                        this.isLoading = false;
                        this.$nextTick(this.startGame);
                    })
                    .catch(err => this.showErrorMessage(err));
                if (!this.timer && !this.prepareForGame) {
                    this.setTimer();
                }
                this.isNextExampleButtonShown = false;
            },
            isItCorrectCouple (couple) {
                if (couple.correctAnswer === 'equality') {
                    return couple.left.numberValue === couple.right.numberValue
                } else if (couple.correctAnswer.match('inequality')) {
                    return couple.correctAnswer.match('>')
                      ? couple.left.numberValue > couple.right.numberValue
                      : couple.left.numberValue < couple.right.numberValue
                }
                return couple.left.numberValue + couple.right.numberValue === +couple.correctAnswer;
            },
            couplesDone () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts = this.isAttemptCorrect
                    ? this.chainOfAttempts[this.amountOfExamples - 1].length
                    : this.chainOfAttempts[this.amountOfExamples].length;
                this.gameStat.answers = this.amountOfExamples;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },
            shakeAnswerBlocks () {
                let answerBlocks = document.getElementsByClassName('answer');
                let amount = answerBlocks.length;
                let timeouts = [];
                for (let i = 0; i < amount; i++) {
                    timeouts.push(setTimeout(() => {
                        if (answerBlocks[i]) {
                            answerBlocks[i].classList.add('shake');
                        }
                    }, i * 100));
                }
                setTimeout(() => {
                    for(let j = 0; j < timeouts.length; j++) {
                        clearTimeout(timeouts[j]);
                    }
                    for (let i = 0; i < amount; i++) {
                        if (answerBlocks[i]) {
                            answerBlocks[i].classList.remove('shake');
                        }
                    }
                }, 2000)
            },
            handleScrollOfAnswersBox(e) {
                e = window.event || e;
                let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                document.querySelector('.answers-container').scrollLeft -= (delta*65);
                e.preventDefault();
            },
            addFocusOnReplyButton () {
                let replyButton = document.getElementById('reply-button');
                replyButton.focus();
            },
            updateCouples () {
                this.couples.forEach(couple => {
                    let rightCoupleValue = couple.correctAnswer !== 'equality'
                        ? +couple.correctAnswer.match(/(\d+)/)[0] - couple.left.numberValue
                        : couple.left.numberValue;
                    [ , couple.right] = this.getImages(couple.left.numberValue, rightCoupleValue);
                    return couple;
                })
            },
            fillCouples () {
                for (let i = 0; i < this.parameters.amountOfPairs; i++) {
                    let [leftCoupleValue, rightCoupleValue, correctAnswer] = this.generateMathExample();
                    let [leftItem, rightItem] = this.getImages(leftCoupleValue, rightCoupleValue);
                    this.couples.push({
                        left: leftItem,
                        right: rightItem,
                        correctAnswer
                    })
                    this.usedImages.push(leftItem.id, rightItem.id);
                }
            },
            generateMathExample () {
                let difficulties = this.parameters.difficulties;
                if (this.parameters.difficulties.some(difficult => {
                    return this.couples.some(couple => couple.correctAnswer !== difficult)
                })) {
                    difficulties = difficulties.filter(difficult => {
                        return !this.couples.map(couple => couple.correctAnswer).includes(difficult);
                    });
                }
                let selectedDifficulty = _.shuffle(this.parameters.difficulties)[0];
                let firstTerm, secondTerm;
                switch (selectedDifficulty) {
                    case ('equality'):
                        firstTerm = this.getRandomInt(1, 10);
                        return [firstTerm, firstTerm, selectedDifficulty];
                    case ('inequality'):
                        do {
                            firstTerm = this.getRandomInt(1, 10);
                            secondTerm = this.getRandomInt(1, 10);
                        } while (firstTerm === secondTerm);
                        selectedDifficulty += firstTerm > secondTerm ? '>' : '<';
                        selectedDifficulty += 'WithSum' + (firstTerm + secondTerm);
                        return [firstTerm, secondTerm, selectedDifficulty];
                    default:
                        do {
                            firstTerm = this.getRandomInt(1, selectedDifficulty)
                            secondTerm = selectedDifficulty - firstTerm
                        } while (firstTerm > 10 || secondTerm > 10)
                        return [firstTerm, secondTerm, selectedDifficulty]
                }
            },
            getRandomInt (min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            getImages (leftCoupleValue, rightCoupleValue) {
                let leftItem, rightItem;
                if (this.parameters.leftColumn === 'image') {
                    let filteredImages = this.imageCouples.filter(couple => couple.numberValue === leftCoupleValue);
                    if (filteredImages.some(image => !this.usedImages.includes(image.id))) {
                        filteredImages = filteredImages.filter(image => !this.usedImages.includes(image.id));
                    }
                    leftItem = _.shuffle(filteredImages)[0];
                } else {
                    const filteredDigits = this.digitCouples.filter(couple => couple.numberValue === leftCoupleValue);
                    leftItem = _.shuffle(filteredDigits)[0];
                }
                leftItem.type = 'image';
                if (this.parameters.rightColumn === 'image') {
                    let filteredImages = this.imageCouples.filter(couple => {
                        return couple.numberValue === rightCoupleValue && couple.id !== leftItem.id
                    });
                    if (filteredImages.some(image => !this.usedImages.includes(image.id))) {
                        filteredImages = filteredImages.filter(image => !this.usedImages.includes(image.id));
                    }
                    rightItem = _.shuffle(filteredImages)[0];
                } else {
                    const filteredDigits = this.digitCouples.filter(couple => couple.numberValue === rightCoupleValue);
                    rightItem = _.shuffle(filteredDigits)[0];
                }
                rightItem.type = 'image';
                return [leftItem, rightItem]
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            },
            rotateCarousel () {
                this.rotateButtonClicked = true;
            },
            endCarouselRotate () {
                this.rotateButtonClicked = false;
            }
        },
        components: {
            GamePreparationCounter,
            AnswerContainer,
            Reels,
            Drag,
            Drop,
        },
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .play-box__links {
        margin-bottom: 20px;
        @include media($sm) {
            margin-bottom: 25px;
        }
    }

    .play-box__link {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .link__icon {
        margin-right: 20px;
    }

    .play-box__example {
        margin-bottom: 20px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: inherit;
        @include media($xlg) {
            justify-content: center;
            flex-direction: row;
        }
    }

    .reels-container {
        overflow: hidden;
        height: 100%;
        max-height: 500px;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__drop {
        display: flex;
        justify-content: center;
        min-height: 110px;
        width: 100%;
        @include media($sm) {
            min-height: 145px;
        }
        @include media($md) {
            min-height: 195px;
        }
        @include media($lg) {
            min-height: 240px;
        }
        @include media($xlg) {
            min-height: 215px;
        }
        @include media($xl) {
            min-height: 240px;
        }
        @include media($xxl) {
            min-height: 305px;
        }
    }

    .play-box__word {
        padding: 10px;
        margin: 0 10px 10px 0;
        background: $x-color-white;
        border-radius: $border-radius-5;

        word-break: break-all;

        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 20px;
        @include media($sm) {
            margin-bottom: 30px;
        }
        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }
    }

    .play-box__title {
        margin-bottom: 20px;
    }

    .play-box__subtitle {
        margin-bottom: 0;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 30px 0 0;
        @include media($xlg) {
            margin: 0 0 0 30px;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 30px 0 0;
        @include media($xlg) {
            margin: 0 0 0 30px;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($md) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>

